// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"89d84c73497acbe590e9","418":"230ceb50ce6fd73a9eec","661":"2284681ed346acd13031"}[chunkId] + ".bundle.js";
};